import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class CourseModel extends Model 
{
	@attr name;
	@attr length;
	@attr homologation;
	@attr TC;
	@attr MC;
	@attr HD;
	@attr lapLength;
	@attr numLaps;
	
	@belongsTo('event', {inverse: 'courses', async: true}) EventId;
	@hasMany('class-group', {inverse: 'CourseId', async: true}) classGroups;
	@hasMany('course-element', {inverse: 'CourseId', async: true}) courseElements;
	@hasMany('segment', {inverse: 'CourseId', async: true}) segments;

	get courseElementsInCourseOrder()
	{
		return this.get('courseElements').then((ces) => 
		{
			return ces.slice().sort((a,b) => (a.order - b.order));
		});
	}
}